import storeManager from '../StoreManager';

const branchRuleReader = {
    hasEvaluatedBranchRules() {
        const state = storeManager.getState();
        if (state.branchRule.hasEvaluated) {
            return true;
        }
        return state.assessment.sections
            .filter((section) => { return section.questions.length > 0; })
            .length === 2;
    },
    hasBranchRules() {
        return storeManager.getState().assessment.hasBranchRules;
    },
};

export default branchRuleReader;
